<template>
  <div>
    <div v-if="isLoading" class="shipping-preview">
      <!-- Loading shippings... -->
    </div>
    <div v-else>
      <div v-if="!addresses || addresses.length === 0" class="shipping-preview">
        <span v-translate>No addresses are here... yet.</span>
      </div>
      <address-list-item v-for="(address, index) in addresses" :address="address" :key="address.reference + index" />
      <paginator :totalPages="totalPages" :currentPage.sync="currentPage" />
    </div>
    <spinner />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddressListItem from '@/components/AddressListItem'
import Paginator from '@/components/Paginator'
import { FETCH_ADDRESSES } from '@/store/actions.type'
import Spinner from '@/components/Spinner'

export default {
  name: 'AddressList',
  components: {
    AddressListItem,
    Paginator,
    Spinner
  },
  props: {
    itemsPerPage: {
      type: Number,
      required: false,
      default: 5
    }
  },
  data() {
    return {
      currentPage: 1
    }
  },
  computed: {
    listConfig() {
      const filters = {
        page: this.currentPage - 1,
        limit: this.itemsPerPage,
        sort: [{
          key: 'created_at',
          direction: 'desc'
        }]
      }
      return {
        filters
      }
    },
    pages() {
      if (this.isLoading || this.addressesCount <= this.itemsPerPage) {
        return []
      }
      return [...Array(Math.ceil(this.addressesCount / this.itemsPerPage)).keys()].map(e => e + 1)
    },
    totalPages() {
      return Math.ceil(this.addressesCount / this.itemsPerPage)
    },
    ...mapGetters([
      'addressesCount',
      'isLoading',
      'addresses'
    ])
  },
  watch: {
    currentPage(newValue) {
      this.listConfig.filters.offset = (newValue - 1) * this.itemsPerPage
      this.listConfig.filters.page = (newValue - 1)
      this.fetchAddresses()
    }
  },
  created() {
    this.fetchAddresses()
  },
  methods: {
    fetchAddresses() {
      this.$store.dispatch(FETCH_ADDRESSES, this.listConfig)
    },
    resetPagination() {
      this.listConfig.offset = 0
      this.currentPage = 1
    },
    setList(filter) {
      this.type = filter
    }
  }
}
</script>
